import { render, staticRenderFns } from "./PhaseBaseReward.vue?vue&type=template&id=abd3946c&"
import script from "./PhaseBaseReward.vue?vue&type=script&lang=js&"
export * from "./PhaseBaseReward.vue?vue&type=script&lang=js&"
import style0 from "./PhaseBaseReward.vue?vue&type=style&index=0&id=abd3946c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports